


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AInfo from '@/components/AInfo.vue';
import { validateAccount, getCurBlockNumber } from '@/utils/web3';
import BigNumber from 'bignumber.js';
import { balanceOf } from '@/contract/woolToken';
import {alpacaCount, exchangePrice, exchangeWoolPrice, exchange, restrictionEndBlock} from '@/contract/alpacaExchange';

@Component({
  components: {
    AlpacaBtn,
    AInfo,
  },
})
export default class AdoptCenter extends Vue {
  @Prop({
    required: true,
  })
  public pid!: number;

  public count: number = 1;
  public remaining: number = -1;
  public myWoolBalance: BigNumber = new BigNumber(0);
  public exchangePrice: BigNumber = new BigNumber(0);
  public exchangeWoolPrice: BigNumber = new BigNumber(0);
  public restrictionEndBlock: number = 0;
  public currentBlock: number = 0;
  public energyRange = [
    '800~1000',
    '1000~1200',
    '1200~1350',
    '1350+',
    '2017',
    '500',
    '2512',
    'must have 1 Gold trait'
  ];

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  get totalWool() {
    return this.exchangeWoolPrice.multipliedBy(this.count);
  }

  get totalETH() {
    return this.exchangePrice.multipliedBy(this.count);
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get canAdopt() {
    return this.remaining !== -1 &&
    this.remaining >= Number(this.count) &&
    this.currentBlock >= this.restrictionEndBlock &&
    !this.notEnoughWool;
  }

  get notEnoughAlpaca() {
    return this.remaining !== -1 &&
    this.remaining < Number(this.count);
  }

  get notEnoughWool() {
    return this.myWoolBalance.isLessThan(this.totalWool);
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getRemaining() {
    const amount = await alpacaCount(this.pid);
    if (amount) {
      this.remaining = amount;
    }
  }

  public async getExchangePrice() {
    const amount = await exchangePrice(this.pid);
    if (amount) {
      this.exchangePrice = new BigNumber(amount);
    }
  }

  public async getExchangeWoolPrice() {
    const amount = await exchangeWoolPrice(this.pid);
    if (amount) {
      this.exchangeWoolPrice = new BigNumber(amount);
    }
  }

  public async getRestrictionEndBlock() {
    const num = await restrictionEndBlock(this.pid, this.account);
    if (num) {
      this.restrictionEndBlock = Number(num);
    }
  }

  public async getCurBlockNumber() {
    const num = await getCurBlockNumber();
    if (num) {
      this.currentBlock = Number(num);
    }
  }

  public async handleAdopt() {
    exchange(this.pid, this.totalETH, this.count, this.account);
  }

  public async getWoolBalance() {
    const amount = await balanceOf(this.account);
    if (amount) {
      this.myWoolBalance = new BigNumber(amount);
    }
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getRemaining();
      this.getExchangeWoolPrice();
      this.getExchangePrice();
      this.getWoolBalance();
      this.getRestrictionEndBlock();
      this.getCurBlockNumber();
    }
  }
}
